export default "__VITE_ASSET__Cijs_vf7__"